export default "__VITE_ASSET__BHYJuQlN__"